export default __webpack_public_path__ + "5705f30db57d03d0098e3ff83193e944.png";